import Loader from '@components/Loader/Loader'
import { FormattedMessage } from 'react-intl'

export default function ChartFormLoader() {
  return (
    <aside id="item-editor-panel">
      <header className="item-editor-header">
        <h3>
          <FormattedMessage id="item-editor.chart.editor-title" />
        </h3>
      </header>
      <div className="item-editor-body item-editor-loader">
        <Loader />
      </div>
    </aside>
  )
}
